import { type CSSProperties, memo } from "react";
import { getTextFontSvg } from "../../constants/textFontSvgs";
import styles from "./TextFontMenu.module.css";

interface FontOptionButtonProps {
    fontFamily: string;
    onClick: (fontFamily: string) => void;
}

export const FontOptionButton = memo(function FontOptionButton({
    fontFamily,
    onClick,
}: FontOptionButtonProps) {
    const svgMarkup = getTextFontSvg(fontFamily);
    const fontStyle = {
        "--item-font-family": `'${fontFamily}'`,
    } as CSSProperties;

    return (
        <button type="button" onClick={() => onClick(fontFamily)} className={styles.item}>
            {svgMarkup ? (
                <div
                    className={styles.itemSvg}
                    // biome-ignore lint/security/noDangerouslySetInnerHtml: <SVG-лейблы шрифтов добавляются из локального реестра>
                    dangerouslySetInnerHTML={{ __html: svgMarkup }}
                />
            ) : (
                <span className={styles.itemFont} style={fontStyle}>
                    {fontFamily}
                </span>
            )}
        </button>
    );
});
